(function (module) {
    'use strict';

    function getFullUrlPath (location) {
        const isHttps = location.protocol === 'https:';
        const path = location.protocol + '//' + location.hostname + ':' + (location.port || (isHttps ? '443' : '80')) + (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname);
        return path;
    }

    function parseQueryString (str) {
        let obj = {};
        let key;
        let value;
        angular.forEach((str || '').split('&'), (keyValue) => {
            if (keyValue) {
                value = keyValue.split('=');
                key = decodeURIComponent(value[0]);
                obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
            }
        });
        return obj;
    }

    class Popup {
        constructor ($interval, $window, $q) {
            this.$interval = $interval;
            this.$window = $window;
            this.$q = $q;
            this.popup = null;
            this.defaults = {
                redirectUri: null
            };
        }

        stringifyOptions (options) {
            const parts = [];
            angular.forEach(options, function (value, key) {
                parts.push(key + '=' + value);
            });
            return parts.join(',');
        }

        open ({ url, redirectUri, popupOptions }) {
            const width = popupOptions.width || 500;
            const height = popupOptions.height || 500;
            const options = this.stringifyOptions({
                width: width,
                height: height,
                top: this.$window.screenY + ((this.$window.outerHeight - height) / 2.5),
                left: this.$window.screenX + ((this.$window.outerWidth - width) / 2)
            });
            const popupName = '_blank';
            this.popup = this.$window.open(url, popupName, options);
            if (this.popup && this.popup.focus) {
                this.popup.focus();
            }
            return this.polling(redirectUri);
        }

        polling (redirectUri) {
            return this.$q((resolve, reject) => {
                const redirectUriParser = document.createElement('a');
                redirectUriParser.href = redirectUri;
                const redirectUriPath = getFullUrlPath(redirectUriParser);
                const polling = this.$interval(() => {

                    if (!this.popup || this.popup.closed || this.popup.closed === undefined) {
                        this.$interval.cancel(polling);
                        reject(new Error('The popup window was closed'));
                    }
                    try {
                        const popupWindowPath = getFullUrlPath(this.popup.location);
                        if (popupWindowPath === redirectUriPath) {
                            if (this.popup.location.search || this.popup.location.hash) {
                                const query = parseQueryString(this.popup.location.search.substring(1).replace(/\/$/, ''));
                                const hash = parseQueryString(this.popup.location.hash.substring(1).replace(/[\/$]/, ''));
                                const params = angular.extend({}, query, hash);
                                if (params.error) {
                                    reject(new Error(params.error));
                                } else {
                                    resolve(params);
                                }
                            } else {
                                reject(new Error('OAuth redirect has occurred but no query or hash parameters were found. ' +
                                    'They were either not set during the redirect, or were removed—typically by a ' +
                                    'routing library—before Satellizer could read it.'));
                            }
                            this.$interval.cancel(polling);
                            this.popup.close();
                        }
                    } catch (error) {
                        // Ignore DOMException: Blocked a frame with origin from accessing a cross-origin frame.
                        // A hack to get around same-origin security policy errors in IE.
                    }
                }, 500);
            });
        }
    }

    module.service('Popup', Popup);

})(angular.module('rocket.components'));
